import { FlexRow } from '@make-software/tg-mini-app-ui';
import React from 'react';

import {
  Field,
  Input,
  LeftSection,
  MagnifierIcon,
  RightSection,
  SearchButton,
  Suffix
} from './styled';

export interface DomainSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  placeholder?: string;
  suffix?: string;
  className?: string;
  disabled?: boolean;
  inputDisabled?: boolean;
}

export const DomainSearchInput: React.FC<DomainSearchInputProps> = ({
  value,
  onChange,
  onSearch,
  placeholder = 'Search your subname',
  suffix = '.fans.cspr',
  className,
  disabled = false,
  inputDisabled = false
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch?.();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <FlexRow align="center" gap={8} className={className}>
      <Field>
        <LeftSection>
          <Input
            id="domain-search-input"
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            spellCheck={false}
            autoCapitalize="none"
            autoCorrect="off"
            aria-label="Search name"
            onKeyDown={handleKeyDown}
            disabled={inputDisabled}
          />
        </LeftSection>
        <RightSection>
          <Suffix aria-hidden="true">{suffix}</Suffix>
        </RightSection>
      </Field>

      <SearchButton type="button" onClick={onSearch} aria-label="Search" disabled={disabled}>
        <MagnifierIcon viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm7.7 4.1-4.1-4.1a1 1 0 1 1 1.4-1.4l4.1 4.1a1 1 0 0 1-1.4 1.4Z"
            fill="currentColor"
          />
        </MagnifierIcon>
      </SearchButton>
    </FlexRow>
  );
};
